import { render } from "./NoticiaView.vue?vue&type=template&id=80073826&scoped=true"
import script from "./NoticiaView.vue?vue&type=script&lang=js"
export * from "./NoticiaView.vue?vue&type=script&lang=js"

import "./NoticiaView.vue?vue&type=style&index=0&id=80073826&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80073826"]])

export default __exports__